<template>
  <DataList
    title="Контакти"
    resource="crm-contacts"
    :columns="columns"
    :get-items-fn="getContacts"
  />
</template>

<script>
import DataList from "../../../components/DataList.vue";
import * as companiesApi from "../../backend/contactsApi.js";

export default {
  components: {
    DataList,
  },
  data: () => ({
    columns: [
      { title: "ФіП", name: "title" },
      { title: "Контактні телефони", name: "phones" },
      { title: "Email", name: "emails" },
      { title: "Посада", name: "position" },
    ],
  }),
  methods: {
    async getContacts(...args) {
      var data = await companiesApi.getContacts(args[0], args[1], args[2], args[3]);
      data.result = data.result.map(e=>{
        return {
          id: e.id,
          title: `${e.surname} ${e.name} ${e.middlename}`,
          phones: e.phones.join(","),
          emails: e.emails.join(","),
          position: e.position,
        };
      });

      return data;
    },
  },
};
</script>